<template>
  <div :class="`common-search-form ${className}`">
    <div class="search-models" :style="{ maxHeight: showMore ? '100vh' : '80px' }">
      <el-row class="search-row" type="flex" :gutter="5">
        <el-col
          v-for="(form, index) in forms.filter((f) => typeof f.visible !== 'function' || f.visible(params))"
          :key="index"
          :span="form.colSpan || 8"
        >
          <div class="custom-form-item">
            <span v-if="form.label" class="custom-form-label" :style="{ width: labelWidth + 'px' }">{{
              form.label
            }}</span>
            <template v-if="form.slotName">
              <slot :name="form.slotName" :scope="{ params, modelValue: form.modelValue }"></slot>
            </template>
            <el-input
              v-else-if="form.itemType === 'input'"
              clearable
              v-bind="form || {}"
              v-model="params[form.modelValue]"
              @keyup.enter="searchHandler"
              @clear="searchHandler"
            />
            <el-select
              v-else-if="form.itemType === 'select'"
              clearable
              filterable
              :remote="!!form.remote"
              :remote-method="form.remote ? form.remoteMethod : undefined"
              :loading="!!form.remoteLoading"
              v-bind="form || {}"
              v-model="params[form.modelValue]"
              @change="searchHandler"
            >
              <el-option
                v-for="option in form.options"
                :key="option[form.valueKey || 'value']"
                :value="typeof option === 'object' ? option[form.valueKey || 'value'] : option"
                :label="typeof option === 'object' ? option[form.labelKey || 'label'] : option"
              />
            </el-select>
            <el-date-picker
              v-else-if="form.itemType === 'date'"
              clearable
              v-bind="form || {}"
              type="datetime"
              format="YYYY-MM-DD HH:mm:ss"
              value-format="YYYY-MM-DD HH:mm:ss"
              v-model="params[form.modelValue]"
              :shortcuts="pickerSingleOptions.shortcuts"
              @change="searchHandler"
            />
            <el-date-picker
              v-else-if="form.itemType === 'datetime'"
              clearable
              v-bind="form || {}"
              v-model="params[form.modelValue]"
              format="YYYY-MM-DD HH:mm:ss"
              value-format="YYYY-MM-DD HH:mm:ss"
              :shortcuts="pickerSingleOptions.shortcuts"
              type="datetime"
              @change="searchHandler"
            />
            <el-date-picker
              v-else-if="form.itemType === 'daterange'"
              clearable
              v-bind="form || {}"
              v-model="params[form.modelValue]"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="YYYY-MM-DD HH:mm:ss"
              value-format="YYYY-MM-DD HH:mm:ss"
              :shortcuts="pickerRangeOptions.shortcuts"
              @change="(date) => changeDate(date, form.prop, form.modelValue)"
            />
            <el-date-picker
              v-else-if="form.itemType === 'datetimerange'"
              clearable
              v-bind="form || {}"
              type="datetimerange"
              v-model="params[form.modelValue]"
              @change="(date) => changeDate(date, form.prop, form.modelValue)"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="YYYY-MM-DD HH:mm:ss"
              value-format="YYYY-MM-DD HH:mm:ss"
              :shortcuts="pickerRangeOptions.shortcuts"
            />
          </div>
        </el-col>
      </el-row>
      <div :class="`search-handle ${btnHandle ? 'search-handle-width' : ''}`" :span="5">
        <div class="btn-handle">
          <el-button :size="size" v-if="!hideResetBtn" @click="resetForm" :loading="loading">
            {{ resetBtnText }}
          </el-button>
          <el-button type="primary" :size="size" @click="searchHandler" :loading="loading">
            {{ submitBtnText }}
          </el-button>
          <slot name="btnSlot"></slot>
        </div>
        <div v-if="showMoreBtn" style="text-align: right">
          <el-button type="text" @click="lookMore">
            <div class="btn-more-box" :class="showMore ? 'show-more' : ''">
              更多查询条件
              <div class="btn-more-icon">
                <svg-icon iconClass="ant-double-left"></svg-icon>
              </div>
            </div>
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formProps } from './props';
import { pickerRangeOptions, pickerSingleOptions, pickerIntervalOptions, dateClear } from '@/utils/datePickerOption';

export default {
  name: 'SearchForm',
  props: formProps,
  emits: ['input', 'update:modelValue', 'search', 'reset'],
  data() {
    return {
      // 是否显示更多查询条件
      showMore: false,
      // 原始参数，用于重置
      originParams: {},
      pickerRangeOptions,
      pickerSingleOptions
    };
  },
  computed: {
    currentValue() {
      // 支持 Vue 3 v-model (modelValue) 和 Vue 2 兼容 (:value)
      return this.modelValue !== undefined ? this.modelValue : this.value;
    },
    params: {
      get() {
        return this.currentValue || {};
      },
      set(value) {
        this.$emit('update:modelValue', value);
        this.$emit('input', value);
      }
    }
  },
  mounted() {
    const v = this.currentValue;
    this.originParams = v ? JSON.parse(JSON.stringify(v)) : {};
  },
  methods: {
    resetForm() {
      this.params = JSON.parse(JSON.stringify(this.originParams));
      this.$emit('reset');
    },
    changeDate(date, prop, modelValue) {
      dateClear();
      // 结束日期未手动选择具体时间时，默认补到当天 23:59:59，保证查询包含一整天
      if (prop && Array.isArray(prop)) {
        const [startDate, endDate] = prop;
        if (Array.isArray(date) && date.length === 2) {
          if (/\s00:00:00$/.test(date[1])) {
            date[1] = date[1].replace(/\s00:00:00$/, ' 23:59:59');
          }
          this.params[startDate] = date[0];
          this.params[endDate] = date[1];
        } else {
          this.params[startDate] = '';
          this.params[endDate] = '';
        }
      }
      if (modelValue) {
        this.params[modelValue] = date;
      }
    },
    searchHandler() {
      this.$emit('search');
    },
    lookMore() {
      this.showMore = !this.showMore;
    }
  }
};
</script>

<style lang="scss" scoped>
.common-search-form {
  height: 100%;
  padding: 20px;
  border-radius: $--border-radius-base;
  background-color: $--color-white;
}

.search-models {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  .search-row {
    flex-wrap: wrap;
    row-gap: 10px;
    flex: 1;
  }
  .search-handle {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 20%;
    flex-shrink: 0;
    .btn-handle {
      width: 100%;
      text-align: right;
    }
    .btn-more-box {
      @include flexBetweenCenter;
      gap: 2px;
      font-size: 13px;
      .btn-more-icon {
        transform: rotate(-90deg);
        transition: all 0.3s ease-in-out;
      }
      &.show-more .btn-more-icon {
        transform: rotate(-270deg);
      }
    }
  }
  .search-handle-width {
    width: 35%;
  }
}

.balance-search {
 padding: 0;
}

:deep(.custom-form-item){
  display: flex;
  align-items: center;
  gap: 10px;
  .custom-form-label {
    text-align: right;
    font-size: 14px;
    flex-shrink: 0;
  }
}
</style>

<style>
.common-search-form .el-select,
.common-search-form .el-date-editor {
  width: 100% !important;
}
</style>
